import { RiskKeys } from '@/config';
import { ComplianceAlertsData } from '@/redux/models';

export const alertsDemoData: ComplianceAlertsData = {
  entries: [
    {
      key: '1',
      id: '1',
      user: 'John Doe',
      address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
      causingTxHash:
        '0xda7b34e91a5c8f20b39d1e7a8b9c0a1f2e3d4c5b6a7f8e9d0c1b2a3f4e5d6c7b',
      direction: 'income',
      risk: 'low',
      riskyFunds: 100,
      entityCategory: RiskKeys.EXCHANGE,
      state: 'new',
      date: '2021-09-01',
      customer: [
        {
          id: '1',
          name: 'John Doe',
          identifier: 'John Doe',
          level: 'medium',
        },
      ],
    },
    {
      key: '2',
      id: '2',
      user: 'Jane Doe',
      address: '0x9a8b7c6d5e4f3a2b1c0d9e8f7a6b5c4d3e2f1a0b',
      causingTxHash:
        '0xfa8e29d1c3b5a7f9e2d4c8b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5',
      direction: 'outcome',
      risk: 'medium',
      riskyFunds: 200,
      entityCategory: RiskKeys.TRUSTED_EXCHANGE,
      state: 'pending',
      date: '2021-09-02',
      customer: [
        {
          id: '1',
          name: 'John Doe',
          identifier: 'John Doe',
          level: 'medium',
        },
      ],
    },
    {
      key: '3',
      id: '3',
      user: 'Alice Doe',
      address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
      causingTxHash:
        '0xda7b34e91a5c8f20b39d1e7a8b9c0a1f2e3d4c5b6a7f8e9d0c1b2a3f4e5d6c7b',
      direction: 'income',
      risk: 'high',
      riskyFunds: 300,
      entityCategory: RiskKeys.WALLET,
      state: 'confirmed',
      date: '2021-09-03',
      customer: [
        {
          id: '1',
          name: 'John Doe',
          identifier: 'John Doe',
          level: 'medium',
        },
      ],
    },
  ],
  total: 3,
};
